<template>
  <div>
    <div id="vue" class="wrap">
      <div class="container">
        <div class="mt-4">
          <h3 class="mr-4 mb-3">
            <i class="fas fa-search mr-2"></i>
            路燈認養
          </h3>
        </div>
        <div class="row mt-2">
          <div class="col-sm-12">
            <div class="card">
              <div class="card-body">
                <div class="row">
                </div>
                <div class="row">
                 
                  <div class="col-12"><hr></div>
                  <div class="col-12">
                    <h5>查詢</h5>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group">
                      <label for="district" class="">行政區</label>
                      <select @change="update_select" name="district" id="district" class="form-control selectpicker" title="請選擇" v-model="district_id">
                        <option v-for="d in district_list" :key="d.id" :value="d.id">{{d.name}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <date-rangepicker-component ref="dpicker" label="認養日期" autocomplete="off" ></date-rangepicker-component>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group">
                      <label for="" class="">關鍵字</label>
                      <input type="text" class="form-control" v-model="keyword">
                    </div>
                  </div>
                 
                  
                </div>

                <hr class="border-secondary">
                <div class="d-flex justify-content-center">
                  <button style="width: 150px;" class="btn btn-outline-info" @click="search">搜尋</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-if="result">
          <div class="col-sm-12">
            <div class="card">
              <div class="card-body">
                <h4>查詢結果</h4>

                <div class="table-responsive">
                    <table id="table" class="table border table-lg table-striped dt-responsive nowrap p-0" cellspacing="0" width="100%">
                      <thead>
                        <tr>
                          <th>序號</th>
                          <th>認養者</th>
                          <th>認捐數量</th>
                          <th>認養期間</th>
                        </tr>
                      </thead>
                    </table>
                  </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "../../../apis/main.js"
import DateRangepickerComponent from './DateRangepickerComponent.vue';
import dlang from '../dlang.json'
let $ = window.$;
export default {
  name: 'SearchPage',
  props: {
  },
  components: {
    DateRangepickerComponent
  },
  data() {
    return {
      district_id: "",
      keyword: "",
      start_date: "",
      end_date: "",
      region_list: [],
      result: [],
      dateRange:'',
    }
  },
  computed: {
    district_list() {
      if(this.region_list.length == 0) return [];
      return this.region_list.map(ele=>{
        return {
          id: ele.id,
          name: ele.name
        }
      })
    },
    village_list() {
      let d_id = this.district_id;
      if (d_id == '') return [];
      let res = this.region_list.filter(ele => {
        return ele.id == d_id;
      })[0].village_list;
       res.unshift({
        id: '',
        name: ''
      });
      return res;
    }
  },
  mounted() {
    $('#table').DataTable({
      responsive: true,
      language:  dlang,
      searching: false,
      processing: true,
      paging: false,
      lengthChange: false,
      dom: "<'table-responsive'tr>" +
            "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
      order: [],
      columnDefs: [
        { className: 'text-center', targets: [-1] },
        { orderable: false, targets: '_all'},
      ],
    });
    $('.selectpicker').selectpicker({
      container:'body',
      size: 6,
      dropupAuto: false
    });
    this.getRegion().then(res=>{
      this.region_list = res.data
      this.region_list.unshift({
        id: '',
        name: ''
      });
      this.$nextTick(()=>{
        $('.selectpicker').selectpicker('refresh')
      })
    });
    this.search();
  },
  created() {
  },
  methods: {
    async getRegion() {
      let res = await api.get("get_district_village_option");
      return res;
    },
    onSearch: function(){
      const {start, end} = this.dateRange;
      console.log('開始日期',start);
      console.log('結束日期',end);
    },

    async search() {
      let drange = this.$refs.dpicker.val || "~";
      let start = drange.split('~')[0].trim();
      let end = drange.split('~')[1].trim();
      
      if (start) start += 'T00:00:00';
      if (end) end += 'T23:59:59';

      let params = {
        ...(this.district_id && { district_id: this.district_id }),
        ...(start && { start_date: start }),
        ...(end && { end_date: end }),
        ...(this.keyword && { keyword: this.keyword })
      };

      this.$nextTick(() => {
        $('#table').DataTable().destroy();
        $('#table').DataTable({
          responsive: true,
          language: dlang,
          searching: false,
          processing: true,
          serverSide: true,
          pageLength: 50,
          lengthMenu: [[50], [50]],
          ajax: (data, callback) => {
            const queryParams = new URLSearchParams(params).toString();
            let url = `pw_query_streetlight_adopt?${queryParams}`;
            url = `${url}&start_from_row=${data.start}&rows_per_page=50`;

            api.post(url).then(res => {
              const tableData = res.data.data.map(e => [
                e.adopt_no,
                e.adopter_name
                  ? (e.adopter_name.length === 1
                      ? e.adopter_name
                      : e.adopter_name[0] +
                        '○'.repeat(e.adopter_name.length - 2) +
                        e.adopter_name[e.adopter_name.length - 1])
                  : '',
                e.adopt_count,
                (e.adopt_start_date || e.adopt_end_date)
                  ? `${e.adopt_start_date ? e.adopt_start_date.split('T')[0] : ''} ~ ${e.adopt_end_date ? e.adopt_end_date.split('T')[0] : ''}`
                  : ''
              ]);

              callback({
                data: tableData,
                recordsTotal: res.data.total_row,
                recordsFiltered: res.data.total_row,
                draw: data.draw
              });
            }).catch(error => {
              console.error('查詢錯誤:', error);
              callback({
                data: [],
                recordsTotal: 0,
                recordsFiltered: 0,
                draw: data.draw
              });
            });
          },
          dom: "<'table-responsive'tr>" +
               "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
          order: [],
          columnDefs: [
            { className: 'text-center', targets: [-1] },
            { orderable: false, targets: '_all' }
          ]
        });
      });
    }
  },
  watch: {
    district_id: function() {
      this.$nextTick(()=>{
        $('.selectpicker').selectpicker('refresh')
      })
    }
  }
}
</script>

<style scoped>
</style>
